import {api, ApiResponse} from "@/data/api/portal"

export interface Environment {
  scope: string;
  id: string;
  title: string;
  industry?: string;
  contacts?: string;
  zohoUrl?: string;
  sageCode?: string;
  wave?: string;
  applications?: string;
  licences?: string;
  status: string;
  statusDescription: string;
  searchString: string;
}

export interface ApplicationMetadata {
  id: string;
  title: string;
  shortTitle?: string;
  stableVersion?: string;
  stableVersionBuiltOn?: string;
  releaseCandidateVersion?: string;
  releaseCandidateVersionBuiltOn?: string;
  links?: Link[];
}

export interface Application {
  id: string;
  title: string;
  url: string;
  version?: string;
  baselineVersionTitle?: string;
  upgradeToBaselineVersion?: string;
  upgradeInProgress?: boolean;
  buildDate?: string;
  status: string;
  statusDescription: string;
  licence: string;
  links?: Link[];
}

export interface EnvironmentStatus {
  realm: string;
  id: string;
  title: string;
  contacts: string;
  zohoLink?: string;
  applications: Application[];
  databases: {
    title: string;
    host: string;
    port: number;
    instance: string;
  }[];
  k8sLink?: string;
}

export interface Link {
  id: string;
  title: string;
  url: string;
}

export async function getEnvironments() {
  const r = await api.get("/environments")
  return r.data as Environment[]
}

export async function getEnvironment(id: string) {
  try {
    const r = await api.get("/environment", {params: {id}})
    return r.data as EnvironmentStatus
  } catch (e) {
    console.error(e)
    return undefined
  }
}

export async function getApplications() {
  const r = await api.get("/applications")
  return r.data as ApplicationMetadata[]
}

export interface AppUpgradeInfo {
  env: string;
  app: string;
  versionTitle: string;
  version: string;
}

export async function upgradeApp(upgradeInfo: AppUpgradeInfo) {
  console.log("/applicationUpgrade", upgradeInfo)
  try {
    const r = await api.post("/applicationUpgrade", upgradeInfo)
    return r.data as EnvironmentStatus
  } catch (e) {
    console.error(e)
    return undefined
  }
}

export async function updateFirewall(firewallRules: string): Promise<ApiResponse<void>> {
  console.warn("Not implemented yet:", firewallRules)
  return { ok: false, }
}

export interface UserRoles {
  roleNames: string[];
}

export async function userRoles() {
  try {
    const r = await api.get("/userRoles")
    return r.data as UserRoles
  } catch (e) {
    console.error(e)
    return undefined
  }
}
